import styled from "styled-components";
import { StyledText, StyledTextInput } from "../../../../components/common";
import DropDownArrow from "../../../../components/svgs/dropDownArrow";

// Validation functions
const validateEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email) ? null : "Please enter a valid Email Address";
};

const validatePhone = (phone) => {
  return (
    String(phone).match(/^0\d{9,10}$/) ||
    String(phone).match(/^\+\d{1,3}\d{9,10}$/)
  );
};

const validateBusinessDetails = (details) => {
  return details && details.trim() !== ""
    ? null
    : "Please share your business details";
};

export const ContactDetailsPage = ({ state, handleChange }) => {
  const emailErrorMessage = validateEmail(state?.emailAddress);
  const whatsappErrorMessage = validatePhone(state?.whatsappNumber);
  const businessDetailsErrorMessage =
    state?.ownBusiness === "yes"
      ? validateBusinessDetails(state?.businessDetails)
      : null;

  // Validation checks for new fields
  const isEducationLevelValid = state?.educationLevel !== "";
  const isOwnBusinessValid = state?.ownBusiness !== "";
  const isEventSourceValid = state?.eventSource !== "";
  const isOnlinePresenceValid = state?.onlinePresence !== "";

  return (
    <MainWrapper>
      <StyledText
        size={24}
        margin={0}
        style={{ fontFamily: "MTNMedium", marginBottom: "5px" }}
      >
        Contact Details
      </StyledText>
      <StyledText
        size={12}
        margin={0}
        style={{ fontFamily: "MTNRegular", marginBottom: "20px" }}
      >
        Enter your details below
      </StyledText>

      {/* Full Name */}
      <FormTextField
        placeholder="Full Name"
        value={state?.fullname || ""}
        hasError={state?.errors?.includes("fullname")}
        onChange={(val) => handleChange("fullname", val)}
        errorMessage="Please enter Full Name"
      />

      {/* Phone */}
      <FormTextField
        placeholder="Phone"
        value={state?.phone || ""}
        hasError={state?.errors?.includes("phone")}
        onChange={(val) => {
          handleChange("phone", val);
          if (!validatePhone(val)) {
            handleChange("errors", [...state.errors, "phone"]);
          } else {
            handleChange(
              "errors",
              state.errors.filter((err) => err !== "phone")
            );
          }
        }}
        errorMessage="Please enter a valid Phone Number"
      />

      {/* Email Address */}
      <FormTextField
        placeholder="Email Address"
        value={state?.emailAddress || ""}
        hasError={state?.errors?.includes("emailAddress")}
        onChange={(val) => {
          handleChange("emailAddress", val);
          if (validateEmail(val)) {
            handleChange("errors", [...state.errors, "emailAddress"]);
          } else {
            handleChange(
              "errors",
              state.errors.filter((err) => err !== "emailAddress")
            );
          }
        }}
        errorMessage={emailErrorMessage || "add an error message if not filled"}
      />

      {/* WhatsApp Number */}
      <FormTextField
        placeholder="WhatsApp Number"
        value={state?.whatsappNumber || ""}
        hasError={state?.errors?.includes("whatsappNumber")}
        onChange={(val) => {
          handleChange("whatsappNumber", val);
          if (!validatePhone(val)) {
            handleChange("errors", [...state.errors, "whatsappNumber"]);
          } else {
            handleChange(
              "errors",
              state.errors.filter((err) => err !== "whatsappNumber")
            );
          }
        }}
        errorMessage={
          whatsappErrorMessage || "Please enter a valid WhatsApp Number"
        }
      />

      {/* Level of Education */}
      <StyledSelectWrapper>
        <StyledSelect
          value={state?.educationLevel || ""}
          hasError={
            !isEducationLevelValid && state?.errors?.includes("educationLevel")
          }
          onChange={(e) => {
            const value = e.target.value;
            handleChange("educationLevel", value);
            if (value === "") {
              handleChange("errors", [...state.errors, "educationLevel"]);
            } else {
              handleChange(
                "errors",
                state.errors.filter((err) => err !== "educationLevel")
              );
            }
          }}
        >
          <option value="">Select Level of Education</option>
          <option value="highschool">High School</option>
          <option value="undergraduate">Undergraduate Degree</option>
          <option value="postgraduate">Post Graduate Degree</option>
          <option value="other">Other</option>
        </StyledSelect>
        <DropDownWrapper>
          <DropDownArrow />
        </DropDownWrapper>
      </StyledSelectWrapper>
      {!isEducationLevelValid && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          Please select your Level of Education.
        </StyledText>
      )}

      {/* Do you own a business */}
      <StyledSelectWrapper>
        <StyledSelect
          value={state?.ownBusiness || ""}
          hasError={
            !isOwnBusinessValid && state?.errors?.includes("ownBusiness")
          }
          onChange={(e) => {
            const value = e.target.value;
            handleChange("ownBusiness", value);
            if (value === "") {
              handleChange("errors", [...state.errors, "ownBusiness"]);
            } else {
              handleChange(
                "errors",
                state.errors.filter((err) => err !== "ownBusiness")
              );
            }
          }}
        >
          <option value="">Do you own a business?</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </StyledSelect>
        <DropDownWrapper>
          <DropDownArrow />
        </DropDownWrapper>
      </StyledSelectWrapper>
      {!isOwnBusinessValid && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          Please select if you own a business.
        </StyledText>
      )}

      {/* Business Name and Details (Conditional) */}
      {state?.ownBusiness === "yes" && (
        <>
          <FormTextField
            placeholder="What is the name of your business?"
            value={state?.businessName || ""}
            hasError={state?.errors?.includes("businessName")}
            onChange={(val) => handleChange("businessName", val)}
            errorMessage={
              businessDetailsErrorMessage ||
              "What is the name of your business?"
            }
          />
          <FormTextField
            placeholder="What product or services does your business offer?"
            value={state?.businessDetails || ""}
            hasError={state?.errors?.includes("businessDetails")}
            onChange={(val) => handleChange("businessDetails", val)}
            errorMessage={
              businessDetailsErrorMessage ||
              "Please share your business details"
            }
          />
        </>
      )}

      {/* Does your business have an online presence? */}
      <StyledSelectWrapper>
        <StyledSelect
          value={state?.onlinePresence || ""}
          hasError={
            !isOnlinePresenceValid && state?.errors?.includes("onlinePresence")
          }
          onChange={(e) => {
            const value = e.target.value;
            handleChange("onlinePresence", value);
            if (value === "") {
              handleChange("errors", [...state.errors, "onlinePresence"]);
            } else {
              handleChange(
                "errors",
                state.errors.filter((err) => err !== "onlinePresence")
              );
            }
          }}
        >
          <option value="">Does your business have an online presence?</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </StyledSelect>
        <DropDownWrapper>
          <DropDownArrow />
        </DropDownWrapper>
      </StyledSelectWrapper>
      {!isOnlinePresenceValid && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          Please indicate if your business has an online presence.
        </StyledText>
      )}

      {/* If Yes, share details */}
      {state?.onlinePresence === "yes" && (
        <FormTextField
          placeholder="Can you share your details?"
          value={state?.onlineDetails || ""}
          hasError={state?.errors?.includes("onlineDetails")}
          onChange={(val) => handleChange("onlineDetails", val)}
          errorMessage="Please share your online presence details"
        />
      )}

      {/* How did you hear about this event */}
      <StyledSelectWrapper>
        <StyledSelect
          value={state?.eventSource || ""}
          hasError={
            !isEventSourceValid && state?.errors?.includes("eventSource")
          }
          onChange={(e) => {
            const value = e.target.value;
            handleChange("eventSource", value);
            if (value === "") {
              handleChange("errors", [...state.errors, "eventSource"]);
            } else {
              handleChange(
                "errors",
                state.errors.filter((err) => err !== "eventSource")
              );
            }
          }}
        >
          <PlaceholderOption value="">
            How did you hear about this event?
          </PlaceholderOption>
          <option value="socialMedia">Social Media</option>
          <option value="friends">Friends</option>
          <option value="advertisement">Advertisement</option>
          <option value="other">Other</option>
        </StyledSelect>
        <DropDownWrapper>
          <DropDownArrow />
        </DropDownWrapper>
      </StyledSelectWrapper>
      {!isEventSourceValid && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          Please select how you heard about the event.
        </StyledText>
      )}
      <HorizontalLine />
    </MainWrapper>
  );
};

const FormTextField = ({
  value,
  onChange,
  placeholder,
  hasError,
  errorMessage,
}) => {
  const style = {
    textAlign: "left",
    width: "100%",
    fontSize: "13px",
    maxWidth: "400px",
    padding: "15px 10px",
    margin: "0 auto 5px auto",
    boxSizing: "border-box",
    border: hasError ? "1px solid red" : "1px solid #ccc",
  };

  return (
    <>
      <StyledTextInput
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        value={value}
        style={style}
      />
      {hasError && (
        <StyledText
          margin={0}
          size={10}
          style={{
            fontFamily: "MTNRegular",
            color: "red",
            margin: "0px 0 10px 0",
          }}
        >
          {errorMessage}
        </StyledText>
      )}
    </>
  );
};

const StyledSelect = styled.select`
  width: 100%;
  max-width: 400px;
  padding: 15px 10px;
  margin: 0 auto 10px auto;
  box-sizing: border-box;
  font-size: 13px;
  font-family: MTNRegular;
  // color: black;
  color: ${({ value }) => (value === "" ? "#999" : "black")};
  border: 1px solid #ccc;
  background: white;
  appearance: none;

  &:focus {
    outline: none;
    border-color: #ccc;
  }
`;

const PlaceholderOption = styled.option`
  color: gray; /* Placeholder color */
`;

const HorizontalLine = styled.div`
  margin: 20px 0;
  border-top: none;
  border-bottom: 1px solid #ddd;
`;

const MainWrapper = styled.div`
  margin-bottom: 20px;
`;

const DropDownWrapper = styled.div`
  position: absolute;
  top: 30%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
`;

const StyledSelectWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
`;
